import { useState } from "react";
import { hotTags } from "@/mocks/guaData";

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (keyword.trim()) {
      const t = document.getElementById("content");
      if (t) {
        t.scrollIntoView({ behavior: "smooth" });
        window.dispatchEvent(new CustomEvent("gua-search", { detail: keyword.trim() }));
      }
    }
  };

  return (
    <section id="top" className="relative min-h-[560px] md:min-h-[680px] w-full flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=%E5%A8%B1%E4%B9%90%E8%88%9E%E5%8F%B0%E7%9A%84%E5%A4%9C%E6%99%9A%E7%81%AF%E5%85%89%E7%9B%9B%E5%85%B8%E6%B0%9B%E5%9B%B4%EF%BC%8C%E6%B8%A9%E6%9A%96%E8%80%8C%E7%81%AB%E7%83%AD%E7%9A%84%E7%BA%A2%E9%87%91%E8%89%B2%E5%85%89%E5%BD%B1%E7%8E%A9%E5%85%B6%E8%88%9E%E5%8F%B0%E4%B8%8E%E5%BD%A9%E5%B8%A6%E8%A3%85%E7%82%B9%EF%BC%8C%E6%8A%BD%E8%B1%A1%E5%92%8C%E6%B0%94%E6%B0%9B%E7%81%AF%E5%85%89%E7%9A%84%E5%8A%A8%E6%84%9F%E8%83%8C%E6%99%AF%EF%BC%8C%E5%AF%B9%E6%AF%94%E5%BC%BA%E7%83%88%E7%9A%84%E6%B7%B1%E8%89%B2%E8%88%9E%E5%8F%B0%E8%83%8C%E6%99%AF&width=1800&height=1000&seq=gua-hero-2026&orientation=landscape"
          alt="吃瓜频道娱乐热点舞台氛围背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 backdrop-blur border border-white/20 text-white text-xs md:text-sm font-medium">
            <i className="ri-flashlight-fill text-accent-300"></i>
            <span>热门栏目专题盘点 · 王牌栏目独家策划 · 每日精选更新</span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl font-bold text-white leading-tight mt-6 tracking-tight">
            吃瓜频道，<br className="hidden sm:block" />
            你追瓜路上的<span className="text-accent-300">进度条</span>
          </h1>
          <p className="text-white/85 text-base md:text-lg mt-5 leading-relaxed max-w-2xl">
            今日猛料、王牌栏目拆解、网红内幕与全网热瓜一站集齐。明星八卦、网红内幕、综艺影视进展随时有最新动向，
            想追的瓜总有新进展，点开频道即可按栏目索引，第一时间看到最新专题策划与精选内容盘点。
          </p>

          <form onSubmit={onSearch} className="mt-8 max-w-xl flex flex-col sm:flex-row gap-3">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-white/60 text-lg"></i>
              <input
                type="search"
                name="s"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜一搜你想吃的瓜，例如：星动夜航"
                className="w-full h-12 sm:h-13 rounded-xl bg-white/95 text-foreground-900 pl-11 pr-4 text-[15px] outline-none focus:ring-2 focus:ring-accent-300 placeholder:text-foreground-500"
              />
            </div>
            <button
              type="submit"
              className="px-6 h-12 sm:h-13 rounded-xl bg-primary-500 text-background-50 font-semibold text-[15px] whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              开始吃瓜
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center gap-2 max-w-2xl">
            <span className="text-white/70 text-sm mr-1 whitespace-nowrap">热门搜索：</span>
            {hotTags.slice(0, 8).map((tag) => (
              <a
                key={tag}
                href="#content"
                className="px-3 py-1 rounded-full bg-white/10 backdrop-blur border border-white/15 text-white/85 text-xs md:text-sm hover:bg-white/20 whitespace-nowrap transition-colors"
              >
                #{tag}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="h-10 md:h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
      </div>
    </section>
  );
}